var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 287.5 287.5",
    style: {
      enableBackground: "new 0 0 287.5 287.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F68B1F;}\n\t.st1{fill:#6D6E71;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F76912;}\n\t.st4{fill:#6D7A8A;}\n\t.st5{fill:#EBEFF2;stroke:#F76912;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.2,284.5h-239C12.5,284.5,3,275,3,263.2v-239C3,12.5,12.5,3,24.3,3h239c11.7,0,21.2,9.5,21.2,21.2v239 C284.5,275,275,284.5,263.2,284.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101,77.9c20.5,0,41.1,0,61.6,0c4.2,0,7.1,2,8.1,5.5c1.3,4.7-2,9.2-7,9.5c-1.2,0.1-2.4,0-3.6,0 c-39.9,0-79.8,0-119.6,0c-2.2,0-4.3,0-6.2-1.4c-2.6-1.9-3.8-5.2-2.8-8.4c0.9-2.9,3.8-5.1,6.9-5.2c6.8,0,13.7,0,20.5,0 C72.9,77.9,86.9,77.9,101,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.1,131.9c-12.9,0-25.8,0-38.7,0c-4.6,0-7.9-3.1-8-7.5c0-4.2,3-7.5,7.2-7.5c9.6-0.1,19.1-0.1,28.7-0.1 c16.3,0,32.5,0,48.8,0c2.7,0,5,0.7,6.7,2.8c1.8,2.3,2.2,5,1,7.7c-1.2,2.7-3.3,4.4-6.4,4.4C127.3,131.8,114.2,131.9,101.1,131.9 C101.1,131.9,101.1,131.9,101.1,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.9,170.9c-5.1,0-10.3,0-15.4,0c-4.3,0-7.5-3.2-7.6-7.5c-0.1-3.8,3.2-7.5,7.1-7.5c5.3,0,10.6-0.1,15.9-0.1 c5.1,0,10.3,0,15.4,0c4.5,0,7.9,3.4,7.9,8c0,3.9-3.5,7.2-7.8,7.2C111.2,170.9,106,170.9,100.9,170.9 C100.9,170.9,100.9,170.9,100.9,170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101,209.6c-4.3,0-7.5-3.2-7.5-7.4c0-4.2,3.4-7.4,7.8-7.5c3.7,0,7.1,3.5,7.1,7.4 C108.4,206.6,104.7,209.9,101,209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.6,209.6c-20.5,0-41.1,0-61.6,0c-4.2,0-7.1-2-8.1-5.5c-1.3-4.7,2-9.2,7-9.5c1.2-0.1,2.4,0,3.6,0 c39.9,0,79.8,0,119.6,0c2.2,0,4.3,0,6.2,1.4c2.6,1.9,3.8,5.2,2.8,8.4c-0.9,2.9-3.8,5.1-6.9,5.2c-6.8,0-13.7,0-20.5,0 C214.6,209.6,200.6,209.6,186.6,209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.4,155.6c12.9,0,25.8,0,38.7,0c4.6,0,7.9,3.1,8,7.5c0,4.2-3,7.5-7.2,7.5c-9.6,0.1-19.1,0.1-28.7,0.1 c-16.3,0-32.5,0-48.8,0c-2.7,0-5-0.7-6.7-2.8c-1.8-2.3-2.2-5-1-7.7c1.2-2.7,3.3-4.4,6.4-4.4C160.2,155.7,173.3,155.6,186.4,155.6 C186.4,155.6,186.4,155.6,186.4,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.6,116.6c5.1,0,10.3,0,15.4,0c4.3,0,7.5,3.2,7.6,7.5c0.1,3.8-3.2,7.5-7.1,7.5c-5.3,0-10.6,0.1-15.9,0.1 c-5.1,0-10.3,0-15.4,0c-4.5,0-7.9-3.4-7.9-8c0-3.9,3.5-7.2,7.8-7.2C176.3,116.6,181.5,116.6,186.6,116.6 C186.6,116.6,186.6,116.6,186.6,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.5,77.9c4.3,0,7.5,3.2,7.5,7.4c0,4.2-3.4,7.4-7.8,7.5c-3.7,0-7.1-3.5-7.1-7.4 C179.1,80.9,182.8,77.6,186.5,77.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEducation);
export default __webpack_public_path__ + "static/media/logo-education.86e1b345788bbc8fab944c3ce530e8f9.svg";
export { ForwardRef as ReactComponent };